"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatBonusAmount = void 0;
const ItemInstance_1 = require("../../classes/ItemInstance");
const retrommo_types_1 = require("retrommo-types");
const definables_1 = require("definables");
const getWorldState_1 = require("../state/getWorldState");
const getStatBonusAmount = (stat) => {
    const worldState = (0, getWorldState_1.getWorldState)();
    let amount = 0;
    if (worldState.values.bodyItemInstanceID !== null) {
        const bodyItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.bodyItemInstanceID);
        switch (stat) {
            case retrommo_types_1.Stat.Agility:
                amount += bodyItemInstance.item.equipmentPiece.agility;
                break;
            case retrommo_types_1.Stat.Defense:
                amount += bodyItemInstance.item.equipmentPiece.defense;
                break;
            case retrommo_types_1.Stat.Intelligence:
                amount += bodyItemInstance.item.equipmentPiece.intelligence;
                break;
            case retrommo_types_1.Stat.Luck:
                amount += bodyItemInstance.item.equipmentPiece.luck;
                break;
            case retrommo_types_1.Stat.Strength:
                amount += bodyItemInstance.item.equipmentPiece.strength;
                break;
            case retrommo_types_1.Stat.Wisdom:
                amount += bodyItemInstance.item.equipmentPiece.wisdom;
                break;
        }
    }
    if (worldState.values.headItemInstanceID !== null) {
        const headItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.headItemInstanceID);
        switch (stat) {
            case retrommo_types_1.Stat.Agility:
                amount += headItemInstance.item.equipmentPiece.agility;
                break;
            case retrommo_types_1.Stat.Defense:
                amount += headItemInstance.item.equipmentPiece.defense;
                break;
            case retrommo_types_1.Stat.Intelligence:
                amount += headItemInstance.item.equipmentPiece.intelligence;
                break;
            case retrommo_types_1.Stat.Luck:
                amount += headItemInstance.item.equipmentPiece.luck;
                break;
            case retrommo_types_1.Stat.Strength:
                amount += headItemInstance.item.equipmentPiece.strength;
                break;
            case retrommo_types_1.Stat.Wisdom:
                amount += headItemInstance.item.equipmentPiece.wisdom;
                break;
        }
    }
    if (worldState.values.mainHandItemInstanceID !== null) {
        const mainHandItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.mainHandItemInstanceID);
        switch (stat) {
            case retrommo_types_1.Stat.Agility:
                amount += mainHandItemInstance.item.equipmentPiece.agility;
                break;
            case retrommo_types_1.Stat.Defense:
                amount += mainHandItemInstance.item.equipmentPiece.defense;
                break;
            case retrommo_types_1.Stat.Intelligence:
                amount += mainHandItemInstance.item.equipmentPiece.intelligence;
                break;
            case retrommo_types_1.Stat.Luck:
                amount += mainHandItemInstance.item.equipmentPiece.luck;
                break;
            case retrommo_types_1.Stat.Strength:
                amount += mainHandItemInstance.item.equipmentPiece.strength;
                break;
            case retrommo_types_1.Stat.Wisdom:
                amount += mainHandItemInstance.item.equipmentPiece.wisdom;
                break;
        }
    }
    if (worldState.values.offHandItemInstanceID !== null) {
        const offHandItemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, worldState.values.offHandItemInstanceID);
        switch (stat) {
            case retrommo_types_1.Stat.Agility:
                amount += offHandItemInstance.item.equipmentPiece.agility;
                break;
            case retrommo_types_1.Stat.Defense:
                amount += offHandItemInstance.item.equipmentPiece.defense;
                break;
            case retrommo_types_1.Stat.Intelligence:
                amount += offHandItemInstance.item.equipmentPiece.intelligence;
                break;
            case retrommo_types_1.Stat.Luck:
                amount += offHandItemInstance.item.equipmentPiece.luck;
                break;
            case retrommo_types_1.Stat.Strength:
                amount += offHandItemInstance.item.equipmentPiece.strength;
                break;
            case retrommo_types_1.Stat.Wisdom:
                amount += offHandItemInstance.item.equipmentPiece.wisdom;
                break;
        }
    }
    for (const boostItemInstanceID of worldState.values.boostItemInstanceIDs) {
        const itemInstance = (0, definables_1.getDefinable)(ItemInstance_1.ItemInstance, boostItemInstanceID);
        const boost = itemInstance.item.ability.boost;
        if (boost.stat === stat) {
            amount += boost.amount;
        }
    }
    return amount;
};
exports.getStatBonusAmount = getStatBonusAmount;
